import type { TranslationTree } from '../../types';

export const referenceAliases: TranslationTree = {
  referenceAliases: {
    tabs: {
      title: 'Referenz-Aliasse',
    },
    displayMode: {
      title: 'Anzeigemodus',
      reference: 'Referenz',
      alias: 'Alias',
      save: 'Speichern',
    },
    table: {
      reference: 'Referenz',
      alias: 'Alias',
      actions: 'Aktionen',
      empty: 'Noch keine Aliasse definiert.',
      loading: 'Laden...',
    },
    form: {
      add: 'Alias hinzufügen',
      edit: 'Alias bearbeiten',
      delete: 'Alias löschen',
      referencePlaceholder: 'Referenz auswählen',
      aliasPlaceholder: 'z.B. Einsatz-Alu-6mm',
      save: 'Speichern',
      cancel: 'Abbrechen',
    },
    errors: {
      duplicateAlias: 'Dieser Alias wird bereits für eine andere Referenz verwendet.',
      emptyFields: 'Referenz und Alias sind erforderlich.',
      noCompany: 'Bitte wählen Sie zuerst ein Unternehmen aus.',
      default: 'Ein Fehler ist aufgetreten.',
    },
    companyPicker: {
      label: 'Unternehmen',
      placeholder: 'Unternehmen auswählen…',
      prompt: 'Wählen Sie ein Unternehmen aus, um dessen Referenz-Aliasse zu verwalten.',
    },
    helperText: 'Bekannter Alias für diese Referenz: {{alias}}',
  },
};
